import { IHrDepartmentState } from '@/store/hr-department';
import { IHrDepartmentMutations } from './mutations.types';
import { IHrDepartmentData } from '@/models';

export const mutations: IHrDepartmentMutations = {
  SET_HR_DEPARTMENTS(
    state: IHrDepartmentState,
    payload: IHrDepartmentData[]
  ): void {
    state.hrDepartments = payload;
  },

  ADD_HR_DEPARTMENT(
    state: IHrDepartmentState,
    payload: IHrDepartmentData
  ): void {
    state.hrDepartments.push(payload);
  },

  UPDATE_HR_DEPARTMENT(
    state: IHrDepartmentState,
    payload: IHrDepartmentData
  ): void {
    const index = state.hrDepartments.findIndex(
      (hrDepartment: IHrDepartmentData) => hrDepartment.id === payload.id
    );

    state.hrDepartments.splice(index, 1, payload);
  },

  REMOVE_HR_DEPARTMENT(state: IHrDepartmentState, payload: number): void {
    const index = state.hrDepartments.findIndex(
      (hrDepartment: IHrDepartmentData) => hrDepartment.id === payload
    );

    state.hrDepartments.splice(index, 1);
  },

  SET_LAST_PROMISE(state: IHrDepartmentState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
